<template>
    <div class="modal changelog-modal">
        <div class="modal-content">
            <base-modal-close @close-modal="$emit('close-modal')" />
            <h3>Changelog</h3>
            <slot />
        </div>
    </div>
</template>

<script>
import modal from '@/mixins/modal';

export default {
    mixins: [modal],
};
</script>
